import React, { Component } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import FormikInputField from '~/components/formikInputField/formikInputField';

export const getBriteTanksQuery = gql`
  query tanks($breweryId: Int!) {
    tanks(breweryId: $breweryId, type: BRITE_TANK) {
      id
      name
    }
  }
`;

export class BriteTankModal extends Component {
  render() {
    const { name, brewery, className, value } = this.props;
    return (
      <Query query={getBriteTanksQuery} variables={{ breweryId: brewery.id }} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <p className="ma0">Getting brite tanks</p>;
          }

          if (error) {
            return <p className="ma0">Error getting brite tanks</p>;
          }

          return (
            <FormikInputField type="select" name={name} className={className} value={value}>
              <option />
              {data.tanks.map(t => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </FormikInputField>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(BriteTankModal);



// WEBPACK FOOTER //
// ./src/containers/briteTankDropdown/briteTankDropdown.jsx